import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'
import { deepClone } from '@/utils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { savePrePortLastMilePrice } from '@/api/price/pricePrePortLastMile'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { PriceChargingItem } from '@/class/model/price/PriceChargingItem'
import { PriceRegion } from '@/class/model/price/PriceRegion'
import moment from 'moment'
import uidUtil from '@/utils/uidUtil'

export default {
  methods: {
    // 按箱型计费条目
    getChargingItemByEqSizeDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.chargeItemSet],
              tagValue: 'itemId',
              tagName: this.$store.getters.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.$store.getters.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'),
          colId: 'currency',
          field: 'currency',
          initialWidth: 180,
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          }
        },
        {
          headerName: '20GP',
          colId: 'gp20', field: 'gp20',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          }
        },
        // {
        //   headerName: '20HC', field: 'hc20', colId: 'hc20', width: 200
        // },
        {
          headerName: '40GP',
          colId: 'gp40', field: 'gp40',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          }
        }, {
          headerName: '40HC',
          colId: 'hc40', field: 'hc40',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          }
        }, {
          headerName: '45HC',
          colId: 'hc45', field: 'hc45',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          }
        }, {
          headerName: '20NOR',
          colId: 'nor20', field: 'nor20',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          }
        }, {
          headerName: '40NOR',
          colId: 'nor40', field: 'nor40',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data || params.value === '') {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            },
            distinguishNullAndZero: true
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SpecialRemark'), colId: 'remarks', field: 'remarks', initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        }
      ]
    },

    // 非按箱型计费条目
    getChargingItemNotByEqSizeDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.chargeItemSet],
              tagValue: 'itemId',
              tagName: this.$store.getters.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.$store.getters.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'),
          colId: 'currency',
          field: 'currency',
          initialWidth: 180,
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          }
        },
        {
          headerName: this.$t('SeaExport.MeasureCurrency'),
          colId: 'measure',
          field: 'measure',
          initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              // methodParams: this.getChargeMeasureFilter(),
              filterable: true
            }
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'),
          colId: 'unitRate',
          field: 'unitRate',
          initialWidth: 180,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: () => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          }
        }
      ]
    },

    init() {
      this.initChargeItemSet()
      this.initCurrencySet()
    },

    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.chargeItemSet = new Set(results)
    },

    initCurrencySet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      this.currencySet = new Set(results)
    },

    cancel() {
      if (!this.form.uuid) {
        this.$emit('cancel')
      }
      this.form = deepClone(this.originForm)
      this.isEdit = false
    },

    edit() {
      this.form = deepClone(this.originForm)
      this.isEdit = true
    },

    // 保存
    save() {
      if (this.type === SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code) {
        if (!this.form.pol) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_POL'))
          return
        }
        if (this.form.priceMethod === SystemConstants.PRICE_METHOD_BRANCH.code && !this.form.branchLine) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_SideLineType'))
          return
        }
        // 起运地区域 省 必填
        const row = this.form.priceRegions.find(p => !p.province)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Province'))
          return
        }
      }
      if (this.type === SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code) {
        if (!this.form.podList || this.form.podList.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_POD'))
          return
        }
        this.form.pod = this.form.podList.join(',')
        // 邮编 必填
        let row = this.form.priceRegions.find(p => p.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code && !p.postalCode)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.ZIP'))
          return
        }
        row = this.form.priceRegions.find(p => p.deliveryAddressType !== SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code && !p.warehouseCode)
        if (row) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_WarehouseCode2'))
          return false
        }
      }
      if (!this.form.beginDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_DateFrom'))
        return
      }
      if (!this.form.endDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_CompleteDate'))
        return
      }
      if (this.form.chargingItemByEqSize && this.form.chargingItemByEqSize.length > 0) {
        this.form.chargingItemByEqSize.forEach(item => {
          if (!item.chargeItemId) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_chargeItem'))
            return
          }
          if (!item.currency) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_currency'))
            return
          }
        })
      }
      if (this.form.chargingItemNotByEqSize && this.form.chargingItemNotByEqSize.length > 0) {
        this.form.chargingItemNotByEqSize.forEach(item => {
          if (!item.chargeItemId) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_chargeItem'))
            return
          }
          if (!item.currency) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_currency'))
            return
          }
          if (!item.measure) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.MeasureCurrency'))
            return
          }
          if (!item.unitRate) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('FinanceManage.charge_unitPrice'))
            return
          }
        })
      }
      this.loading = getLoading4Cxt()
      this.form.branchId = this.$store.getters.currentOfficeId
      if (!this.form.delChargingItemUuids) {
        this.form.delChargingItemUuids = []
      }
      if (!this.form.byEqSizeChargingItems) {
        this.form.byEqSizeChargingItems = []
      }
      if (!this.form.notByEqSizeChargingItems) {
        this.form.notByEqSizeChargingItems = []
      }
      this.form.type = this.type
      savePrePortLastMilePrice(this.form).then(res => {
        this.form = res.data
        this.originForm = deepClone(res.data)
        this.isEdit = false
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },

    // 直接上架
    publishDirectly() {
      const now = moment().format('YYYY-MM-DD') + ' 00:00:00'
      console.log('this.form.endDate:', this.form.endDate)
      if (!((this.form.beginDate.length <= 10 ? this.form.beginDate + ' 00:00:00' : this.form.beginDate) <= now &&
          (this.form.endDate.length <= 10 ? this.form.endDate.endDate + ' 00:00:00' : this.form.endDate) >= now)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectValidRateForShelving'))
        return
      }
      this.form.status = SystemConstants.PRICE_STATUS_NORMAL.code
      this.save()
    },

    addChargingItem(chargingItemType) {
      if (chargingItemType === SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code) {
        if (!this.form.byEqSizeChargingItems) {
          this.form.byEqSizeChargingItems = []
        }
        const item = new PriceChargingItem().fillDefaultValue().getData()
        item.type = SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code
        item.tempUuid = uidUtil.createUID()
        this.form.byEqSizeChargingItems.push(item)
      } else {
        if (!this.form.notByEqSizeChargingItems) {
          this.form.notByEqSizeChargingItems = []
        }
        const item = new PriceChargingItem().fillDefaultValue().getData()
        item.type = SystemConstants.CHARGING_ITEM_TYPE_NOT_BY_EQ_SIZE.code
        item.tempUuid = uidUtil.createUID()
        this.form.notByEqSizeChargingItems.push(item)
      }
    },

    delChargingItem(chargingItemType) {
      let selectedRows
      if (chargingItemType === SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code) {
        selectedRows = this.chargingItemByEqSize.selectedRows
        this.chargingItemByEqSize.selectedRows = []
      } else {
        selectedRows = this.chargingItemNotByEqSize.selectedRows
        this.chargingItemNotByEqSize.selectedRows = []
      }
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }

      const delUuids = []
      const delTempUuids = []
      selectedRows.forEach(row => {
        if (row.uuid) {
          delUuids.push(row.uuid)
        } else {
          delTempUuids.push(row.tempUuid)
        }
      })
      if (chargingItemType === SystemConstants.CHARGING_ITEM_TYPE_BY_EQ_SIZE.code) {
        this.form.byEqSizeChargingItems = this.form.byEqSizeChargingItems
          .filter(item => delUuids.indexOf(item.uuid) === -1 && delTempUuids.indexOf(item.tempUuid) === -1)
      } else {
        this.form.notByEqSizeChargingItems = this.form.notByEqSizeChargingItems
          .filter(item => delUuids.indexOf(item.uuid) === -1 && delTempUuids.indexOf(item.tempUuid) === -1)
      }

      if (!this.form.delChargingItemUuids) {
        this.form.delChargingItemUuids = []
      }
      this.form.delChargingItemUuids = [...this.form.delChargingItemUuids, ...delUuids]
    },

    addArea() {
      let priceRegion = new PriceRegion().fillDefaultValue().getData()
      if (this.form.priceRegions && this.form.priceRegions.length > 0) {
        const lastPriceRegions = this.form.priceRegions[this.form.priceRegions.length - 1]
        if (lastPriceRegions) {
          priceRegion = deepClone(lastPriceRegions)
          if (priceRegion.townUuid !== '') {
            priceRegion.townUuid = ''
          } else if (priceRegion.districts !== '') {
            priceRegion.districts = ''
          } else if (priceRegion.city !== '') {
            priceRegion.city = ''
          } else if (priceRegion.province !== '') {
            priceRegion.province = ''
          }
        }
      }
      this.form.priceRegions.push(priceRegion)
    },

    delArea(index) {
      if (!this.isEdit) {
        return
      }
      if (this.form.priceRegions.length === 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMaintainAtLeastOne') + this.$t('CargoMsg.Cargo_OriginAreaSelection'))
        return
      }
      if (this.form.priceRegions[index].uuid) {
        this.form.delPriceRegionsUuids.push(this.form.priceRegions[index].uuid)
      }
      this.form.priceRegions.splice(index, 1)
    },
    postCodeChange(post, priceRegion) {
      if (post) {
        priceRegion.postalCode = post.uuid
        priceRegion.address = post.city
      } else {
        priceRegion.postalCode = ''
        priceRegion.address = ''
      }
    },
    deliveryAddressTypeChange(priceRegion) {
      priceRegion.postalCode = ''
      priceRegion.address = ''
      priceRegion.warehouseCode = ''
    },
    disabledBeginDate(time) {
      return !this.form.endDate || time.getTime() >= new Date(this.form.endDate.length <= 10 ? this.form.endDate + ' 00:00:00' : this.form.endDate).getTime()
    }
  }
}
